import React from 'react'
import Button from 'components/button'

// Save, and a confirmation's go-ahead: the product's blue, rather than the hub's own colour, which a
// primary button takes. Semibold, as white text on a solid fill reads thinner than the same weight on white.
export const BLUE_BUTTON = 'border-blue bg-blue font-semibold text-white hover:bg-blue hover:brightness-95'

/**
 * Cancel and Save, for a setting that waits to be saved: beside a text field while it's being edited,
 * or at the foot of a popover. Save waits for a change. Pressing either keeps focus where it is until
 * the click lands, so buttons that show while a field has focus don't go as it blurs.
 */
export const SaveButtons: React.FC<{
  saving: boolean
  canSave: boolean
  onCancel: () => void
  onSave: () => void
}> = ({ saving, canSave, onCancel, onSave }) => (
  <>
    <Button
      internalType="outline"
      onMouseDown={(event: React.MouseEvent) => event.preventDefault()}
      onClick={onCancel}
      disabled={saving}
    >
      Cancel
    </Button>
    <Button
      internalType="outline"
      className={BLUE_BUTTON}
      onMouseDown={(event: React.MouseEvent) => event.preventDefault()}
      onClick={onSave}
      isLoading={saving}
      disabled={!canSave}
    >
      Save
    </Button>
  </>
)
